import {
    container,
} from '../common-style.jsx'

const pageHeaderStyle = () => ({

    appBar: {
        backgroundColor: "transparent",
        boxShadow: "none",
        borderBottom: "0",
        marginBottom: "0",
        position: "absolute",
        width: "100%",
        zIndex: "1029",
        color: "#555555",
        border: "0",
        borderRadius: "3px",
        padding: "10px 0px",
        transition: "all 150ms ease 0s",
        minHeight: "50px",
        display: "block"
    },
    container: {
        ...container,
        minHeight: "50px",
    },
    primary: {
        backgroundColor: "#FFFFFF",
        color: "#FFFFFF",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)"
    },
    flex: {
        flex: 1
    },
})

export default pageHeaderStyle